// @flow

import ApiObject from '../ApiObject';
import _ from 'lodash';
import ArrayUtils from '../../utils/ArrayUtils';

import KioskOrderTicketSettings from './KioskOrderTicketSettings';
import Order from '../order/Order';

export default class KioskOrderSettings extends ApiObject {

  modes: Array<OrderMode> = [Order.OrderMode.ON_SITE];

  irlPaymentAllowd: boolean = true;

  /**
   * An array of Locale string.
   * @type Array<Locale>
   */
  locales: Array<Locale> = ['fr_FR', 'en_GB'];

  serviceAtTableEnabled: boolean = true;

  /**
   * Array of RestaurantRoom ids
   */
  rooms: Array<string> = [];

  ticketSettings: KioskOrderTicketSettings = new KioskOrderTicketSettings();

  backgroundImage = '';

  advertisingImage = '';

  postJsonAssignation(data) {
    this.locales = data.locales;
    this.modes = data.modes;

    this.ticketSettings = new KioskOrderTicketSettings();
    this.ticketSettings.fromJson(data.ticketSettings);
  }

  //
  // rooms
  //

  getRoomById(roomId: string) {
    return ArrayUtils.find(this.rooms, (other: string) => {
      return other === roomId;
    });
  }

  addRoom(roomId: string) {
    this.rooms.push(roomId);
  }

  deleteRoom(roomId: string) {
    this.rooms = ArrayUtils.deleteObject(this.rooms, (other: string) => {
      return other === roomId;
    });
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/restaurant/KioskOrderSettings.js